import { Dispatch, ThunkAction } from '../../../../../types/actions';
import { IGetState } from '../../../../../types/types';
import { fetchHandler } from '../../../../../util/fetchHandler';
import { REST_CHATS } from '../../../../constants';
import { getRestHeadersPost } from '../../../../helpers/getRestHeadersHelper';
import { Util } from '../../../../../util/util';
import { IComment } from '../../../../../store/model/card/types/IComment';
import { IRestChat } from 'app/types/rest/IRestChat';

//TODO done
/***
* Создаем чат, комент нуден , чтоб заполнить инфу об последнем коментарии в чате
* @param comment
*/
export const joinRest = (
    comment: IComment,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return fetchHandler<IRestChat>(
            Util.getApiUrl(`${REST_CHATS}chat/join`), {
                ...getRestHeadersPost(),
                body: JSON.stringify(comment),
            }
        );
    };
    return action;
};
